import { LoginComponent } from './components/user/login/login.component';
import { BlankComponent } from './components/dashboard/blank/blank.component';
import { CatchHubDashboardComponent } from './components/dashboard/catch-hub-dashboard.component';
import { AuthguardGuard } from './modules/catch-core/routing/authguard.guard';
import { AdminGuard } from './modules/catch-core/routing/admin.guard';
import { ProjectAccessGuard } from './modules/catch-core/routing/project-access.guard';
import { RouterModule, Routes } from '@angular/router';
import { ProfileAndChangePasswordComponent } from './components/user/profile-and-change-password/profile-and-change-password.component';
import { AnimalsDashboardComponent } from './components/dashboard/animals-dashboard/animals-dashboard.component';
// import { OktaCallbackComponent } from '@okta/okta-angular';
import { SettingsTabComponent } from './components/settings/settings-tab/settings-tab.component';
import { DetailComponent } from './components/detail/detail.component';
import { ProjectsViewComponent } from './components/dashboard/projects-view/projects-view.component';
import { PasswordUpdateComponent } from './components/user/password-update/password-update.component';
import { ExternalAnimalComponent } from './components/dashboard/external-animal/external-animal.component';
import { SignUpComponent } from './components/user/signup/signup.component';
import { NgModule } from '@angular/core';
import { PasswordResetComponent } from './components/user/password-reset/password-reset.component';
import * as AppConstants from './modules/catch-core/data/constants/app.constants';
import { VideoListComponent } from './modules/catch-core/component/video-list/video-list.component';
import { CopilotConsentCompleteComponent } from './components/copilot-consent/copilot-consent-complete.component';
import { COPILOT_CONSENT_ROUTE } from './models/copilot/copilot-consent.enum';

export const appRoutes: Routes = [
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'dashboard',
    title: 'Dashboard',
    canActivate: [AuthguardGuard],
    component: CatchHubDashboardComponent,
    children: [
      {
        path: AppConstants.CATCH_INTERNAL_APP_SMARTMAP_LOWER,
        title: 'Map',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/smart-map/smart-map.module').then((m) => m.SmartMapModule),
        outlet: 'mainPanel',
      },
      {
        path: AppConstants.CATCH_INTERNAL_APP_SMARTBOARD_LOWER,
        title: 'Track',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/smart-board/smart-board.module').then((m) => m.SmartBoardModule),
        outlet: 'mainPanel',
      },
      {
        path: AppConstants.CATCH_INTERNAL_APP_DOVIEW_LOWER,
        title: 'Do',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/do-view/do-view.module').then((m) => m.DoViewModule),
        outlet: 'mainPanel',
      },
      {
        path: AppConstants.CATCH_INTERNAL_APP_WIKI_LOWER,
        title: 'Wiki',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/wiki-view/wiki-view.module').then((m) => m.WikiViewModule),
        outlet: 'mainPanel',
      },
      {
        path: AppConstants.CATCH_INTERNAL_APP_SMARTREPORT_LOWER,
        title: 'Report',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/smart-report/smart-report.module').then((m) => m.SmartReportModule),
        outlet: 'mainPanel',
      },
      {
        path: AppConstants.CATCH_INTERNAL_APP_TIMELINE_LOWER,
        title: 'Timeline',
        canActivate: [ProjectAccessGuard],
        loadChildren: () => import('./modules/timeline/timeline.module').then((m) => m.TimelineModule),
        outlet: 'mainPanel',
      },

      {
        path: 'blueprint/:id',
        title: 'Template Editor',
        loadChildren: () => import('./modules/blueprint-editor/blueprint-editor.module').then((m) => m.BlueprintEditorModule),
        outlet: 'mainPanel',
      },
      {
        path: 'shared-edit',
        title: 'Edit Panel',
        loadChildren: () => import('./modules/shared-edit-panel/shared-edit-panel.module').then((m) => m.SharedEditPanelModule),
        outlet: 'rightPanel',
      },
      {
        path: 'admin',
        title: 'Admin',
        canActivate: [AdminGuard],
        loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
        outlet: 'tabPanel',
      },
      {
        path: 'authenticationTab',
        title: 'Details',
        component: DetailComponent,
        outlet: 'tabPanel',
      },
      {
        path: 'appsTab',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'tabPanel',
      },
      {
        path: 'blank',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'tabPanel',
      },
      // {
      //   path: 'settings',
      //   component: SettingsComponent,
      //   outlet: 'mainPanel'
      // },
      {
        path: 'settingsTab',
        title: 'Settings',
        component: SettingsTabComponent,
        outlet: 'mainPanel',
      },
      {
        path: 'products',
        title: 'Products',
        component: AnimalsDashboardComponent,
        outlet: 'mainPanel',
      },
      {
        path: 'blank',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'leftSidePanel',
      },
      {
        path: 'projectsview',
        title: 'Projects',
        component: ProjectsViewComponent,
        outlet: 'mainPanel',
      },
      {
        path: 'navigate/:id/:mapId/:isNewProject',
        title: 'New Project',
        loadChildren: () => import('./modules/navigation-tree-view/navigation-tree-view.module').then((m) => m.NavigationTreeViewModule),
        outlet: 'leftSidePanel',
      },
      {
        path: 'external-animal/:url',
        title: 'External Link',
        component: ExternalAnimalComponent,
        outlet: 'mainPanel',
      },
      {
        path: 'profileandchangepwd',
        title: 'Change Password',
        component: ProfileAndChangePasswordComponent,
        outlet: 'rightPanel',
      },
      {
        path: 'addeditproject',
        title: 'Add Project',
        loadChildren: () => import('./modules/add-edit-project/add-edit-project.module').then((m) => m.AddEditProjectModule),
        outlet: 'rightPanel',
      },
      {
        path: 'addeditproject/:id',
        title: 'Add/Edit Project',
        loadChildren: () => import('./modules/add-edit-project/add-edit-project.module').then((m) => m.AddEditProjectModule),
        outlet: 'rightPanel',
      },
      {
        path: 'videoList',
        title: 'Video List',
        component: VideoListComponent,
        outlet: 'rightPanel',
      },
      {
        path: 'copy-project/:id',
        title: 'Copy Project',
        loadChildren: () => import('./modules/copy-project/copy-project.module').then((m) => m.CopyProjectModule),
        outlet: 'rightPanel',
      },
      {
        path: 'project-attachments/:id',
        title: 'Project Attachments',
        loadChildren: () => import('./modules/project-attachments/project-attachments.module').then((m) => m.ProjectAttachmentsModule),
        outlet: 'rightPanel',
      },
      {
        path: 'blankmain',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'mainPanel',
      },
      {
        path: 'blank',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'rightPanel',
      },
      {
        path: 'blank',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'rightPanel',
      },
      {
        path: 'blankRightPanel',
        title: 'Blank',
        component: BlankComponent,
        outlet: 'rightPanel',
      },
    ],
  },
  {
    path: '',
    title: 'Login',
    component: LoginComponent,
  },
  {
    path: 'password-reset',
    title: 'Reset Password',
    component: PasswordResetComponent,
  },
  {
    path: 'signup',
    title: 'Sign up',
    component: SignUpComponent,
  },
  {
    path: 'password-update',
    title: 'Change Password',
    component: PasswordUpdateComponent,
  },
  {
    path: COPILOT_CONSENT_ROUTE,
    title: 'Copilot Access',
    component: CopilotConsentCompleteComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
